<template>
  <div>
      <Modal
            v-model="ModalSexsort"
            title="新增比赛组别"
            width="360"
            :footerHide="true"
            :mask-closable="false"
            @on-cancel="handleReset('formValiEditDateSexsort')"
        >
            <Form  ref="formValiEditDateSexsort" :model="formValiEditDateSexsort" :rules="ruleValidateSexsort" :label-width="120" >
                <div class="editDiv">
                    
                    <div class="fromDiv" >
                        <div class="fromDiv_l cf">
                             <FormItem label="组别名称：" prop="sorts">
                                <Select v-model="formValiEditDateSexsort.sorts">
                                    <Option v-for="item in SortNameENGData" :value="item.sortNameCHN+'/'+item.sortID" :key="item.value">{{ item.sortNameCHN }}</Option>
                                </Select>
                            </FormItem>
                            <FormItem label="性别：" prop="sex">
                                <Select v-model="formValiEditDateSexsort.sex">
                                    <Option v-for="item in $PlugIn.sexData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                </Select>
                            </FormItem>
                        </div>
                    </div>
                    <div class="UpBut">
                        <Button class="m-r10px" type="primary" size="large" :disabled="disableds"   @click="SexsortSubmit('formValiEditDateSexsort')">保存</Button>
                    </div>
                </div>
            </Form>
        </Modal>
        <Modal
            v-model="sexGroup.ModalsexGroupList"
            title="比赛组别设置"
            width="560"
            :footerHide="true"
            :mask-closable="false"
        >
            <div class="mainListT cf">
                <Button type="primary" icon="md-add"  @click="addSexsort">新增比赛组别</Button>
            </div>
            <div class="GroupListTable">
                <Table border :columns="SexsortregisterColumns" :data="sexGroup.SexsortregisterData" ></Table>
            </div>
            <div class="GroupUpBut cf">
                <Button class="float-r" type="primary" @click="goEvent"  size="large"  >下一步</Button>
                <Button class="float-l" type="primary"  @click="guoupForm" size="large"  >上一步</Button>
            </div>
        </Modal>
  </div>
</template>

<script>
import {getSort,addSexsort,delGroupSex,getSexsortList} from '@/lib/api/index.js'

let requiredStr = '必选项不能为空！'
export default {
  props: ['gameId','sexGroup','setting'],
  computed:{
    // GroupListDataUp()
    // {
    //   return this.sexGroup.ModalsexGroupList;
    // }
  },
  watch: {
    // GroupListDataUp()
    // {
    //   if(this.sexGroup.ModalsexGroupList)
    //   {
         
          
    //   }
    // }
  },
  data(){
    return {
        //比赛组别
        disableds:false,
        setType:0,
        SortNameENGData:[],
        ModalSexsort:false,
        formValiEditDateSexsort:{
            sex:'',
            sorts:''
        },
        ruleValidateSexsort:{
            sorts: [
                    { required: true, message: requiredStr, trigger: 'blur' }
                ],
            sex: [
                    { required: true, message: requiredStr, trigger: 'blur' ,type: 'number'}
                ],
        },
        ModalSexsortList:false,
        SexsortregisterColumns:[
                {
                    type:'index',
                    title: '序号',
                    width:70,
                    align:'center',
                },
                {
                    key: 'sortType',
                    title: '比赛组别',
                    render: (h, params) =>{
                        return h('div', 
                           params.row.sexSortName
                        );
                    }
                },
                
                {
                    title: '操作',
                    align: 'center',
                    width: 216,
                    render: (h, params) => {
                            return h('div',{
                                style: {
                                    paddingTop: '6px',
                                    paddingBottom: '6px',
                                    
                                }
                            },[
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            this.ModalSexsort=true;
                                            this.formValiEditDateSexsort =  this.$PlugIn.deepClone(params.row);
                                            
                                            this.formValiEditDateSexsort.sorts = params.row.sortNameCHN+'/'+params.row.sortID;
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    
                                    props: {
                                        size: 'small',
                                        type: 'error',
                                    },
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                title: '提示',
                                                content: '<p>您确定要删除吗？</p>',
                                                onOk: () => {
                                                    this.removeGroupSxe(params);
                                                }
                                            });
                                            
                                        }
                                    }
                                }, '删除'),
                                
                            ]);

                    }
                }
        ],
        //比赛组别
    }
  },
  
  methods:{
      removeGroupSxe(obj)
      {
          delGroupSex(obj.row.sexSortID).then(res => {
          
                if(res.data.code == 0){
                    this.$Message.info("删除成功");
                    getSexsortList(this.gameId).then(res => {
                        if(res.data.code == 0){
                            this.$emit('SexsortregisterDataUp',res.data.data);
                        }else if(res.data.code == -2){
                            this.$Message.error("网络连接失败");
                        }else if(res.data.code==10)
                        {
                            this.$Message.info("登录token过期请重新登录");
                            this.$store.dispatch('loginOut');
                        }else{
                            this.$Message.error(res.data.msg);
                        }
                    },err =>{
                        this.$Message.error("网络连接失败");
                    });

                }else if(res.data.code == -2){
                    this.$Message.error("删除失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                    
                }
            },err =>{
                this.$Message.error("网络连接失败");
            });
      },
      addSexsort()
      {
          this.formValiEditDateSexsort.sexSortID = -1;
          this.ModalSexsort=true;
          this.setType = 0;
      },
      //新增比赛组别
      SexsortSubmit(name)
      {
           this.$refs[name].validate((valid) => { 
                if (valid) {
                        this.disableds = true;
                        this.loadings();
                        
                       
                        this.formValiEditDateSexsort.sortNameCHN = this.formValiEditDateSexsort.sorts.split('/')[0];
                        this.formValiEditDateSexsort.sortID = this.formValiEditDateSexsort.sorts.split('/')[1];
                        
                        this.formValiEditDateSexsort.gameID = this.formValiEditDateSexsort.gameId ? this.formValiEditDateSexsort.gameId : this.gameId;
                        this.formValiEditDateSexsort.sexSortName = this.$PlugIn.sexType(this.formValiEditDateSexsort.sex)+this.formValiEditDateSexsort.sortNameCHN;
                        this.formValiEditDateSexsort.sexSortID = this.formValiEditDateSexsort.sexSortID ? this.formValiEditDateSexsort.sexSortID : -1;
                        let updSporterData = this.$PlugIn.deepClone(this.formValiEditDateSexsort);
                        addSexsort(updSporterData).then(res => {//新增
                            if(res.data.code == 0){
                                this.$emit('sexGroupList');
                                if(this.formValiEditDateSexsort.sexSortID==-1)
                                {
                                  this.$Message.info("添加成功");
                                }else{
                                  
                                  this.$Message.info("编辑成功");
                                  this.$store.dispatch('sexsorteventlayerF',this.formValiEditDateSexsort.gameID)
                                }
                                
                                this.ModalSexsort = false;
                                this.disableds = false;
                                this.handleReset (name);
                                this.$Spin.hide();
                            }else if(res.data.code == -2){
                                this.$Message.error("添加失败");
                                this.disableds = false;
                                this.$Spin.hide();
                            }else if(res.data.code==10)
                            {
                                this.$Message.info("登录token过期请重新登录");
                                this.$store.dispatch('loginOut');
                            }else{
                                this.$Message.error(res.data.msg);
                                this.disableds = false;
                                this.$Spin.hide();
                            }
                        },err =>{
                            this.$Message.error("网络连接失败");
                            this.$Spin.hide();
                        });
                } else {
                    this.$Message.error('请完善信息');
                    this.$Spin.hide();
                }
            });
      },
      guoupForm()
      {
   
        this.$emit('groupListShow');
    
      }, 
      goEvent()
      {
        this.$emit('eventListShow');
      }

  },
  created(){},
  mounted(){
      getSort(this.gameId).then(res => {
            if(res.data.code == 0){
                this.SortNameENGData = res.data.data;
            }else if(res.data.code == -2){
                this.$Message.error("网络连接失败");
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
            }
        },err =>{
            this.$Message.error("网络连接失败");
        });
  }
}
</script>
<style scoped  lang="less">
    .GroupUpBut{
      padding-top: 22px;
    }
</style>


// WEBPACK FOOTER //
// src/components/sexGroup.vue